<template>
    <v-dialog @click:outside="$emit('click:outside')" :value="value" max-width="800">
        <v-card>
            <v-img lazy-src="https://picsum.photos/id/497/1080/1080" height="200" :src="src">
                <v-sheet color="rgba(0, 0, 0, 0.5">
                    <v-card-title class="white--text">Support {{ username }} Breasts</v-card-title>
                </v-sheet>
            </v-img>
            <v-card-text>
            </v-card-text>
            <v-card-subtitle>
                Your gift amount will be staked on the BraNFT contract until the purchase amount is met. <sup><a target="_blank" rel="noopener" style="text-decoration: none" href="https://branfts.com/faq?category=wishlist&id=62b201bd8eb73800011fdae8">(details)</a></sup>
            </v-card-subtitle>

            <v-card-actions class="d-flex justify-center">
                <bnft-gift-amount @cancel="$emit('cancel')" :id="uniqueItemId"></bnft-gift-amount>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<style scoped></style>
<script>
import BnftGiftAmount from './BnftGiftAmount.vue';

export default {
    name: 'BnftWishlistSupportDialog',
    components: {
        BnftGiftAmount,
    },
    props: {
        value: Boolean,
        supportItem: Object,
        wishlist: Object,
    },
    computed: {
        src() {
            return this.supportItem?.media?.[0]?.url;
        },
        uniqueItemId() {
            return this.supportItem?.uniqueId;
        },
        username() {
            const username = this.wishlist?.owner
                ? this.$near.parseUsername(this.wishlist.owner)
                : '';
            return this.$mobile && username
                ? username.firstLastPlural
                : username.plural;
        },
    },
};
</script>
